export default "__VITE_ASSET__RKo9Bk_C__"